/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ActionPlanAliases {
  ACTION_GENERATE = 'action-generate',
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  AUTOCOMPLETE_STATUS = 'autocomplete-status',
  CARD_ACTION_PLAN = 'card-action-plan',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ACTION_PLAN = 'deck-action-plan',
  FETCH_ACTION_PLAN = 'fetch-action-plan',
  FETCH_LOCATOR = 'fetch-locator',
  FETCH_STATUS = 'fetch-status',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_LOCATOR = 'field-locator',
  FIELD_PLAN = 'field-plan',
  FIELD_STATUS = 'field-status',
  FILTER = 'filter',
  FILTERED_LIST_0 = 'filtered-list-0',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  MAPPER_STATUS = 'mapper-status',
  PANEL_ACTION_PLAN = 'panel-action-plan',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
  TEXT_STATUS = 'text-status',
}
export { ActionPlanAliases };
